import { render, staticRenderFns } from "./base_icon.vue?vue&type=template&id=1808f6c4"
import script from "./base_icon.vue?vue&type=script&lang=js"
export * from "./base_icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports